import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=d6805a46&"
import script from "./SideBarMenu.vue?vue&type=script&lang=js&"
export * from "./SideBarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports